const mandalas = [
  {
    "id": 0,
    "title": "constitution"
  },
  {
    "id": 1,
    "title": "atama"
  },
  {
    "id": 2,
    "title": "daibouken"
  },
  {
    "id": 3,
    "title": "design-your-time"
  },
  {
    "id": 4,
    "title": "memology"
  },
  {
    "id": 5,
    "title": "kansei"
  },
  {
    "id": 6,
    "title": "seikou"
  }
]

export default mandalas



/** WEBPACK FOOTER **
 ** ./src/Mandalas.js
 **/